// import React from "react";
// import { Input } from "../../../../Components/ui/input";
// import { CalendarDays } from "lucide-react";
// import AllocationCard, { ChannelAllocations } from "./AllocationCard";
// import { OperatorOption } from "./ManageOperatorPopup";
// import AdvancedSettingsCard from "./AdvancedSettingsCard";

// const ReadOnlyField: React.FC<{ label: string; value: string }> = ({
//   label,
//   value,
// }) => (
//   <div className="space-y-1">
//     <label className="block text-sm font-medium text-[#020617]">{label}</label>
//     <Input
//       value={value}
//       readOnly
//       className="h-10 px-3 border-0 bg-muted text-foreground/80 cursor-default"
//     />
//   </div>
// );

// interface CampaignDetailsCardProps {
//   campaignDetails: {
//     campaign_id: number;
//     category_id: number;
//     category_sub_id: number;
//     name: string;
//     campaign_desc?: string;
//     channels: string[];
//     reachFrom: string[];
//     reachTravelTo: string;
//     startDate: string;
//     endDate: string;
//     startTime: string;
//     endTime: string;
//     allocationType: string;
//     timeZone: string;
//   };
//   selectedOperators: Record<string, Record<string, OperatorOption[]>>;
//   setSelectedOperators: React.Dispatch<React.SetStateAction<Record<string, Record<string, OperatorOption[]>>>>;
//   activeChannel: string;
//   setActiveChannel: React.Dispatch<React.SetStateAction<string>>;
//   allocations: ChannelAllocations;
//   editedAllocations: Record<string, Record<string, Record<string, number>>>;
//   setEditedAllocations: React.Dispatch<React.SetStateAction<Record<string, Record<string, Record<string, number>>>>>;
//   operatorTemplates: Record<string, Record<string, Record<string, any>>>;
//   allocationType: string;
//   setAllocationType: React.Dispatch<React.SetStateAction<string>>;
//   roamingAge: string;
//   setRoamingAge: React.Dispatch<React.SetStateAction<string>>;
//   isDuplicatePrevented: boolean;
//   setIsDuplicatePrevented: React.Dispatch<React.SetStateAction<boolean>>;
//   isPremiumOnly?: boolean;
//   setIsPremiumOnly?: React.Dispatch<React.SetStateAction<boolean>>;
//   availableChannels: { channel_id: number; channel_name: string }[];
//   countryToIso: Record<string, string>;
//   channelNameToId: Record<string, number>;
//   setOperatorTemplates: React.Dispatch<React.SetStateAction<Record<string, Record<string, Record<string, any>>>>>;
  
//       roamingDaysByCountry: any;
//       setRoamingDaysByCountry: React.Dispatch<any>;
//       fromCountryISOs: Record<string, string>;
//       fromCountries: string[];
// }

// const CampaignDetailsCard: React.FC<CampaignDetailsCardProps> = ({
//   campaignDetails,
//   selectedOperators,
//   setSelectedOperators,
//   activeChannel,
//   setActiveChannel,
//   allocations,
//   editedAllocations,
//   setEditedAllocations,
//   operatorTemplates,
//   allocationType,
//   setAllocationType,
//   roamingAge,
//   setRoamingAge,
//   isDuplicatePrevented,
//   setIsDuplicatePrevented,
//   isPremiumOnly,
//   setIsPremiumOnly,
//   availableChannels,
//   countryToIso,
//   channelNameToId,
//   setOperatorTemplates,

//     roamingDaysByCountry,
//   setRoamingDaysByCountry,
//   fromCountryISOs,
//   fromCountries,
// }) => {

//   return (
//     <div className="w-full max-w-[600px] mx-auto space-y-5 mb-[100px] text-left">
//       {/* Details Section */}
//       <div className="border rounded-lg bg-white p-4 space-y-5">
//         <div className="text-md font-bold mb-2">Campaign details</div>
//         <ReadOnlyField label="Campaign name" value={campaignDetails.name} />
//         <ReadOnlyField label="Channel" value={campaignDetails.channels.join(", ")} />
//         <ReadOnlyField label="Reach people from" value={campaignDetails.reachFrom.join(", ")} />
//         <ReadOnlyField
//           label="Reach people traveling to"
//           value={campaignDetails.reachTravelTo}
//         />
//       </div>

//       {/* Dates, Times, and Advanced Settings Section */}
//       <div className="border rounded-lg bg-white p-4 space-y-5">
//         <div className="text-md font-semibold mb-2">Schedule</div>
//         <div className="flex gap-4">
//           {/* Campaign start date */}
//           <div className="flex-1">
//             <label className="block text-sm font-medium text-[#020617] mb-1">
//               Campaign start date
//             </label>
//             <div className="relative">
//               <Input
//                 value={campaignDetails.startDate}
//                 readOnly
//                 className="h-10 pr-9 pl-3 border bg-muted text-foreground/80 cursor-default text-sm"
//               />
//               <CalendarDays
//                 className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
//                 aria-hidden="true"
//               />
//             </div>
//           </div>
//           {/* Campaign end date */}
//           <div className="flex-1">
//             <label className="block text-sm font-medium text-[#020617] mb-1">
//               Campaign end date
//             </label>
//             <div className="relative">
//               <Input
//                 value={campaignDetails.endDate}
//                 readOnly
//                 className="h-10 pr-9 pl-3 border bg-muted text-foreground/80 cursor-default text-sm"
//               />
//               <CalendarDays
//                 className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
//                 aria-hidden="true"
//               />
//             </div>
//           </div>
//         </div>
//         {/* Delivery Window */}
//         <div>
//           <label className="block text-sm font-medium text-[#020617] mb-1">
//             Delivery Window
//           </label>
//           <div className="flex gap-4">
//             <Input
//               value={campaignDetails.startTime}
//               readOnly
//               className="h-10 px-2 border bg-muted text-foreground/80 cursor-default text-sm"
//               placeholder="Start Time"
//             />
//             <Input
//               value={campaignDetails.endTime}
//               readOnly
//               className="h-10 px-2 border bg-muted text-foreground/80 cursor-default text-sm"
//               placeholder="End Time"
//             />
//           </div>
//         </div>
//                 {/* Time Zone */}
//         <div className="mt-2">
//           <ReadOnlyField label="Time Zone" value={campaignDetails.timeZone || "-"} />
//         </div>

//         <div className="mt-2">
//           <AdvancedSettingsCard
//             allocationType={allocationType}
//             setAllocationType={setAllocationType}
//             roamingAge={roamingAge}
//             setRoamingAge={setRoamingAge}
//             isDuplicatePrevented={isDuplicatePrevented}
//             setIsDuplicatePrevented={setIsDuplicatePrevented}
//             isPremiumOnly={isPremiumOnly}
//             setIsPremiumOnly={setIsPremiumOnly}
//               roamingDaysByCountry={roamingDaysByCountry}
//               setRoamingDaysByCountry={setRoamingDaysByCountry}
//               fromCountryISOs={fromCountryISOs}
//               fromCountries={fromCountries}
//           />
//         </div>
//       </div>

//       {/* AllocationCard Below */}
//       <div className="h-full">
//         <AllocationCard
//           campaign={campaignDetails}
//           defaultChannel="Whatsapp"
//           allocations={allocations}
//           selectedOperators={selectedOperators}
//           setSelectedOperators={setSelectedOperators}
//           editedAllocations={editedAllocations}
//           setEditedAllocations={setEditedAllocations}
//           activeChannel={activeChannel}
//           setActiveChannel={setActiveChannel}
//           operatorTemplates={operatorTemplates}
//           availableChannels={availableChannels}
//           countryToIso={countryToIso}
//           channelNameToId={channelNameToId}
//           setOperatorTemplates={setOperatorTemplates}
//         />
//       </div>
//     </div>
//   );
// };

// export default CampaignDetailsCard;
import React from "react";
import { Input } from "../../../../Components/ui/input";
import { CalendarDays } from "lucide-react";
import AllocationCard, { ChannelAllocations } from "./AllocationCard";
import { OperatorOption } from "./ManageOperatorPopup";
import AdvancedSettingsCard from "./AdvancedSettingsCard";

const ReadOnlyField: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <div className="space-y-1">
    <label className="block text-sm font-medium text-[#020617]">{label}</label>
    <Input
      value={value}
      readOnly
      className="h-10 px-3 border-0 bg-muted text-foreground/80 cursor-default"
    />
  </div>
);

interface CampaignDetailsCardProps {
  campaignDetails: {
    campaign_id: number;
    category_id: number;
    category_sub_id: number;
    name: string;
    campaign_desc?: string;
    channels: string[];
    reachFrom: string[];
    reachTravelTo: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    allocationType: string;
    timeZone: string;
  };
  selectedOperators: Record<string, Record<string, OperatorOption[]>>;
  setSelectedOperators: React.Dispatch<React.SetStateAction<Record<string, Record<string, OperatorOption[]>>>>;
  activeChannel: string;
  setActiveChannel: React.Dispatch<React.SetStateAction<string>>;
  allocations: ChannelAllocations;
  editedAllocations: Record<string, Record<string, Record<string, number>>>;
  setEditedAllocations: React.Dispatch<React.SetStateAction<Record<string, Record<string, Record<string, number>>>>>;
  operatorTemplates: Record<string, Record<string, Record<string, any>>>;
  allocationType: string;
  setAllocationType: React.Dispatch<React.SetStateAction<string>>;
  roamingAge: string;
  setRoamingAge: React.Dispatch<React.SetStateAction<string>>;
  isDuplicatePrevented: boolean;
  setIsDuplicatePrevented: React.Dispatch<React.SetStateAction<boolean>>;
  isPremiumOnly?: boolean;
  setIsPremiumOnly?: React.Dispatch<React.SetStateAction<boolean>>;
  availableChannels: { channel_id: number; channel_name: string }[];
  countryToIso: Record<string, string>;
  channelNameToId: Record<string, number>;
  setOperatorTemplates: React.Dispatch<React.SetStateAction<Record<string, Record<string, Record<string, any>>>>>;
  roamingDaysByCountry: any;
  setRoamingDaysByCountry: React.Dispatch<any>;
  fromCountryISOs: Record<string, string>;
  fromCountries: string[];
  audienceType?: string;
  selectedCampaignName?: string;
  campaignStatus?: string;
}

const CampaignDetailsCard: React.FC<CampaignDetailsCardProps> = ({
  campaignDetails,
  selectedOperators,
  setSelectedOperators,
  activeChannel,
  setActiveChannel,
  allocations,
  editedAllocations,
  setEditedAllocations,
  operatorTemplates,
  allocationType,
  setAllocationType,
  roamingAge,
  setRoamingAge,
  isDuplicatePrevented,
  setIsDuplicatePrevented,
  isPremiumOnly,
  setIsPremiumOnly,
  availableChannels,
  countryToIso,
  channelNameToId,
  setOperatorTemplates,
  roamingDaysByCountry,
  setRoamingDaysByCountry,
  fromCountryISOs,
  fromCountries,
  audienceType,
  selectedCampaignName,
  campaignStatus
}) => {

  return (
    <div className="w-full max-w-[600px] mx-auto space-y-5 mb-[100px] text-left">
      {/* Details Section */}
      <div className="border rounded-lg bg-white p-4 space-y-5">
        <div className="text-md font-bold mb-2">Campaign details</div>
        <ReadOnlyField label="Campaign name" value={campaignDetails.name} />
        <ReadOnlyField label="Channel" value={campaignDetails.channels.join(", ")} />
        <ReadOnlyField label="Reach people from" value={campaignDetails.reachFrom.join(", ")} />
        <ReadOnlyField
          label="Reach people traveling to"
          value={campaignDetails.reachTravelTo}
        />
      </div>

      {/* Dates, Times, and Advanced Settings Section */}
      <div className="border rounded-lg bg-white p-4 space-y-5">
        <div className="text-md font-semibold mb-2">Schedule</div>
        <div className="flex gap-4">
          {/* Campaign start date */}
          <div className="flex-1">
            <label className="block text-sm font-medium text-[#020617] mb-1">
              Campaign start date
            </label>
            <div className="relative">
              <Input
                value={campaignDetails.startDate}
                readOnly
                className="h-10 pr-9 pl-3 border bg-muted text-foreground/80 cursor-default text-sm"
              />
              <CalendarDays
                className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
                aria-hidden="true"
              />
            </div>
          </div>
          {/* Campaign end date */}
          <div className="flex-1">
            <label className="block text-sm font-medium text-[#020617] mb-1">
              Campaign end date
            </label>
            <div className="relative">
              <Input
                value={campaignDetails.endDate}
                readOnly
                className="h-10 pr-9 pl-3 border bg-muted text-foreground/80 cursor-default text-sm"
              />
              <CalendarDays
                className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
        {/* Delivery Window */}
        <div>
          <label className="block text-sm font-medium text-[#020617] mb-1">
            Delivery Window
          </label>
          <div className="flex gap-4">
            <Input
              value={campaignDetails.startTime}
              readOnly
              className="h-10 px-2 border bg-muted text-foreground/80 cursor-default text-sm"
              placeholder="Start Time"
            />
            <Input
              value={campaignDetails.endTime}
              readOnly
              className="h-10 px-2 border bg-muted text-foreground/80 cursor-default text-sm"
              placeholder="End Time"
            />
          </div>
        </div>
        {/* Time Zone */}
        <div className="mt-2">
          <ReadOnlyField label="Time Zone" value={campaignDetails.timeZone || "-"} />
        </div>

        <div className="mt-2">
          <AdvancedSettingsCard
            allocationType={allocationType}
            setAllocationType={setAllocationType}
            roamingAge={roamingAge}
            setRoamingAge={setRoamingAge}
            isDuplicatePrevented={isDuplicatePrevented}
            setIsDuplicatePrevented={setIsDuplicatePrevented}
            isPremiumOnly={isPremiumOnly}
            setIsPremiumOnly={setIsPremiumOnly}
            roamingDaysByCountry={roamingDaysByCountry}
            setRoamingDaysByCountry={setRoamingDaysByCountry}
            fromCountryISOs={fromCountryISOs}
            fromCountries={fromCountries}
            audienceType={audienceType}
            selectedCampaignName={selectedCampaignName}
            
          />
        </div>
      </div>

      {/* AllocationCard Below */}
      <div className="h-full">
<AllocationCard
          campaign={campaignDetails}
          defaultChannel="Whatsapp"
          allocations={allocations}
          selectedOperators={selectedOperators}
          setSelectedOperators={setSelectedOperators}
          editedAllocations={editedAllocations}
          setEditedAllocations={setEditedAllocations}
          activeChannel={activeChannel}
          setActiveChannel={setActiveChannel}
          operatorTemplates={operatorTemplates}
          availableChannels={availableChannels}
          countryToIso={countryToIso}
          channelNameToId={channelNameToId}
          setOperatorTemplates={setOperatorTemplates}
          audienceType={audienceType}
          campaignStatus={campaignStatus}
        />
      </div>
    </div>
  );
};

export default CampaignDetailsCard;